import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=b35177cc&"
import script from "./EditEvent.vue?vue&type=script&lang=js&"
export * from "./EditEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports